import ymaps from 'ymaps';

$(document).ready(function() {
	let wasMapLoaded = false;

	function isScrolledIntoView(elem) {
		const docViewTop = $(window).scrollTop();
		const docViewBottom = docViewTop + $(window).height();
		const elemTop = $(elem).offset().top;
		const elemBottom = elemTop + $(elem).height();

		return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
	}

	$(window).on('scroll', ()=> {
		if (isScrolledIntoView('.js-map-container') && !wasMapLoaded) loadMap();
	})

	function loadMap() {
		wasMapLoaded = true;

		ymaps.load('https://api-maps.yandex.ru/2.1/?lang=ru_RU')
			.then(maps => {
				const map = new maps.Map($('.js-map-container')[0], {
					center: [59.8872050642274, 30.329207999999994],
					zoom: 12,
					adaptive: true,
					controls: []
				});

				const mapCenter = map.getGlobalPixelCenter();
				const placemark = new maps.Placemark([59.8872050642274, 30.329207999999994], {}, {
					iconLayout: 'default#image',
					iconImageHref: '/img/map-marker.svg',
					iconImageSize: [54, 70],
					iconImageOffset: [-27, -70],
				});

				map.geoObjects.add(placemark);


				function changeMapCenter() {
					if (window.innerWidth >= 1024 && window.innerWidth < 1280) {
						var pixelCenter = [ mapCenter[0] + 311, mapCenter[1] - 100, ];
						var geoCenter = map.options.get('projection').fromGlobalPixels(pixelCenter, map.getZoom());
						map.setCenter(geoCenter);
					}
					else if (window.innerWidth > 1280) {
						var pixelCenter = [ mapCenter[0] + 450, mapCenter[1] - 100, ];
						var geoCenter = map.options.get('projection').fromGlobalPixels(pixelCenter, map.getZoom());
						map.setCenter(geoCenter);
					}
					else {
						map.setCenter([59.8872050642274, 30.329207999999994]);
					}
				}

				changeMapCenter();
				window.addEventListener('resize', changeMapCenter);
			});
	}

    $('.js-form-map').ajaxForm({
        beforeSubmit: function (formData, jqForm, options) {
            jqForm.find('.js-form-input').removeClass('input--error');
            jqForm.find('.js-form-error').text('').hide();
        },
        dataType: 'html',
        success: function (response, status, xhr, jqForm) {
            response = jQuery.parseJSON(response);
            if (response.data.errors) {
                for (var field in response.data.errors) {
                    var errorMessage = response.data.errors[field];
                    var inputWrap = jqForm.find('[name="' + field + '"]').parents('.js-form-item');
                    inputWrap.find('.js-form-input').addClass('input--error');
                    inputWrap.find('.js-form-error').text(errorMessage).show();
                }
            } else {
                jqForm[0].reset();
                showModal('modal-form-map-success');
                reachGoal('form-podv');
            }
            googleCaptchaFooterMap.refresh();
        }
    });
});
